var map = {
	"./Argentina.png": "./src/components/img/Argentina.png",
	"./Berlim.png": "./src/components/img/Berlim.png",
	"./Berlim2.png": "./src/components/img/Berlim2.png",
	"./Brasil.png": "./src/components/img/Brasil.png",
	"./Chile.png": "./src/components/img/Chile.png",
	"./Colômbia.png": "./src/components/img/Colômbia.png",
	"./Floating_Button.png": "./src/components/img/Floating_Button.png",
	"./Não identificado.png": "./src/components/img/Não identificado.png",
	"./Paraguai.png": "./src/components/img/Paraguai.png",
	"./Uruguai.png": "./src/components/img/Uruguai.png",
	"./Venezuela.png": "./src/components/img/Venezuela.png",
	"./account_card_add48.png": "./src/components/img/account_card_add48.png",
	"./account_card_bell48.png": "./src/components/img/account_card_bell48.png",
	"./account_card_details48.png": "./src/components/img/account_card_details48.png",
	"./account_card_lock48.png": "./src/components/img/account_card_lock48.png",
	"./account_card_off48.png": "./src/components/img/account_card_off48.png",
	"./account_card_on48.png": "./src/components/img/account_card_on48.png",
	"./account_card_remove48.png": "./src/components/img/account_card_remove48.png",
	"./account_card_search48.png": "./src/components/img/account_card_search48.png",
	"./alert_circle48.png": "./src/components/img/alert_circle48.png",
	"./alert_octagon2.png": "./src/components/img/alert_octagon2.png",
	"./alert_octagon24x24.png": "./src/components/img/alert_octagon24x24.png",
	"./alert_octagon36x36.png": "./src/components/img/alert_octagon36x36.png",
	"./alert_octagon48.png": "./src/components/img/alert_octagon48.png",
	"./anotacao/#6ee097.png": "./src/components/img/anotacao/#6ee097.png",
	"./anotacao/#86b4f7.png": "./src/components/img/anotacao/#86b4f7.png",
	"./anotacao/#E8D979.png": "./src/components/img/anotacao/#E8D979.png",
	"./anotacao/#F095A1.png": "./src/components/img/anotacao/#F095A1.png",
	"./anotacao/#F8F9FA.png": "./src/components/img/anotacao/#F8F9FA.png",
	"./anotacao/#a0a2a3.png": "./src/components/img/anotacao/#a0a2a3.png",
	"./anotacao/#b78ff2.png": "./src/components/img/anotacao/#b78ff2.png",
	"./anotacao/#f28fe7.png": "./src/components/img/anotacao/#f28fe7.png",
	"./arrow_collapse_down.png": "./src/components/img/arrow_collapse_down.png",
	"./arrow_collapse_left.png": "./src/components/img/arrow_collapse_left.png",
	"./arrow_collapse_up.png": "./src/components/img/arrow_collapse_up.png",
	"./arrow_left24.png": "./src/components/img/arrow_left24.png",
	"./autorenew48.png": "./src/components/img/autorenew48.png",
	"./autorenew_48.png": "./src/components/img/autorenew_48.png",
	"./bell_ring48.png": "./src/components/img/bell_ring48.png",
	"./car_info36.png": "./src/components/img/car_info36.png",
	"./card_green48.png": "./src/components/img/card_green48.png",
	"./chart_line24.png": "./src/components/img/chart_line24.png",
	"./chart_line24b.png": "./src/components/img/chart_line24b.png",
	"./checkbold24.png": "./src/components/img/checkbold24.png",
	"./checkbold24_green.png": "./src/components/img/checkbold24_green.png",
	"./checkbold_100dp.png": "./src/components/img/checkbold_100dp.png",
	"./circle.png": "./src/components/img/circle.png",
	"./circle1.png": "./src/components/img/circle1.png",
	"./circle2.png": "./src/components/img/circle2.png",
	"./circle3.png": "./src/components/img/circle3.png",
	"./circle4.png": "./src/components/img/circle4.png",
	"./circle5.png": "./src/components/img/circle5.png",
	"./circle5plus.png": "./src/components/img/circle5plus.png",
	"./circle9plus.png": "./src/components/img/circle9plus.png",
	"./close.png": "./src/components/img/close.png",
	"./close_100dp.png": "./src/components/img/close_100dp.png",
	"./close_thick2.png": "./src/components/img/close_thick2.png",
	"./close_thick24_red.png": "./src/components/img/close_thick24_red.png",
	"./delete_100dp.png": "./src/components/img/delete_100dp.png",
	"./delete_48dp.png": "./src/components/img/delete_48dp.png",
	"./edit_48dp.png": "./src/components/img/edit_48dp.png",
	"./editoutline.png": "./src/components/img/editoutline.png",
	"./eye48.png": "./src/components/img/eye48.png",
	"./eye_off48.png": "./src/components/img/eye_off48.png",
	"./faixa_temperatura.png": "./src/components/img/faixa_temperatura.png",
	"./flag_variant24.png": "./src/components/img/flag_variant24.png",
	"./ic_antenna_black_48.png": "./src/components/img/ic_antenna_black_48.png",
	"./ic_aviso_cabine.png": "./src/components/img/ic_aviso_cabine.png",
	"./ic_bloqueio_preto.png": "./src/components/img/ic_bloqueio_preto.png",
	"./ic_desengate256.png": "./src/components/img/ic_desengate256.png",
	"./ic_marker_bloqueio.png": "./src/components/img/ic_marker_bloqueio.png",
	"./ic_marker_bloqueio_sem_sinal.png": "./src/components/img/ic_marker_bloqueio_sem_sinal.png",
	"./ic_marker_green2.png": "./src/components/img/ic_marker_green2.png",
	"./ic_marker_green3.png": "./src/components/img/ic_marker_green3.png",
	"./ic_marker_grey2.png": "./src/components/img/ic_marker_grey2.png",
	"./ic_marker_red4.png": "./src/components/img/ic_marker_red4.png",
	"./ic_marker_red6.png": "./src/components/img/ic_marker_red6.png",
	"./ic_panic_off.png": "./src/components/img/ic_panic_off.png",
	"./ic_ponto_vermelho_2.png": "./src/components/img/ic_ponto_vermelho_2.png",
	"./img_flechas.png": "./src/components/img/img_flechas.png",
	"./key_off.png": "./src/components/img/key_off.png",
	"./key_off48.png": "./src/components/img/key_off48.png",
	"./kseg_logo_escrita.png": "./src/components/img/kseg_logo_escrita.png",
	"./kseg_logo_preto.png": "./src/components/img/kseg_logo_preto.png",
	"./link_expirado.png": "./src/components/img/link_expirado.png",
	"./location_marker20.png": "./src/components/img/location_marker20.png",
	"./location_marker48.png": "./src/components/img/location_marker48.png",
	"./lock48.png": "./src/components/img/lock48.png",
	"./map_location48.png": "./src/components/img/map_location48.png",
	"./map_search48.png": "./src/components/img/map_search48.png",
	"./mapa_500.png": "./src/components/img/mapa_500.png",
	"./mapa_aubergine.png": "./src/components/img/mapa_aubergine.png",
	"./mapa_dark.png": "./src/components/img/mapa_dark.png",
	"./mapa_kseg.png": "./src/components/img/mapa_kseg.png",
	"./mapa_noite.png": "./src/components/img/mapa_noite.png",
	"./mapa_tatico.png": "./src/components/img/mapa_tatico.png",
	"./marker_pluscircle_2.png": "./src/components/img/marker_pluscircle_2.png",
	"./marker_pluscircle_3.png": "./src/components/img/marker_pluscircle_3.png",
	"./marker_porta_aberta.png": "./src/components/img/marker_porta_aberta.png",
	"./marker_porta_aberta36.png": "./src/components/img/marker_porta_aberta36.png",
	"./marker_porta_aberta_23.png": "./src/components/img/marker_porta_aberta_23.png",
	"./marker_porta_lateral_aberta2.png": "./src/components/img/marker_porta_lateral_aberta2.png",
	"./marker_truck_open.png": "./src/components/img/marker_truck_open.png",
	"./minus48.png": "./src/components/img/minus48.png",
	"./paint.png": "./src/components/img/paint.png",
	"./pencil_48.png": "./src/components/img/pencil_48.png",
	"./plus.png": "./src/components/img/plus.png",
	"./plus48.png": "./src/components/img/plus48.png",
	"./plus_circle9_2.png": "./src/components/img/plus_circle9_2.png",
	"./plus_circle_256px.png": "./src/components/img/plus_circle_256px.png",
	"./plus_white24.png": "./src/components/img/plus_white24.png",
	"./point_backup.png": "./src/components/img/point_backup.png",
	"./point_backup_arrow.png": "./src/components/img/point_backup_arrow.png",
	"./point_position.png": "./src/components/img/point_position.png",
	"./point_position4_3.png": "./src/components/img/point_position4_3.png",
	"./point_position_green20.png": "./src/components/img/point_position_green20.png",
	"./point_position_red2.png": "./src/components/img/point_position_red2.png",
	"./point_position_red_arrow.png": "./src/components/img/point_position_red_arrow.png",
	"./point_position_yellow.png": "./src/components/img/point_position_yellow.png",
	"./point_position_yellow_arrow.png": "./src/components/img/point_position_yellow_arrow.png",
	"./poligono/#008000.png": "./src/components/img/poligono/#008000.png",
	"./poligono/#0277bd.png": "./src/components/img/poligono/#0277bd.png",
	"./poligono/#12db1c.png": "./src/components/img/poligono/#12db1c.png",
	"./poligono/#3546e6.png": "./src/components/img/poligono/#3546e6.png",
	"./poligono/#4b9f4a.png": "./src/components/img/poligono/#4b9f4a.png",
	"./poligono/#ED4145.png": "./src/components/img/poligono/#ED4145.png",
	"./poligono/#FFA500.png": "./src/components/img/poligono/#FFA500.png",
	"./poligono/#FFFF00.png": "./src/components/img/poligono/#FFFF00.png",
	"./poligono/#bc1fdb.png": "./src/components/img/poligono/#bc1fdb.png",
	"./poligono/#db1d0f.png": "./src/components/img/poligono/#db1d0f.png",
	"./poligono/#eb78e9.png": "./src/components/img/poligono/#eb78e9.png",
	"./poligono/#ed8515.png": "./src/components/img/poligono/#ed8515.png",
	"./poligono/#ef4a33.png": "./src/components/img/poligono/#ef4a33.png",
	"./poligono/#fdd36e.png": "./src/components/img/poligono/#fdd36e.png",
	"./poligono/danger.png": "./src/components/img/poligono/danger.png",
	"./poligono/dark.png": "./src/components/img/poligono/dark.png",
	"./poligono/ic_flag_blue.png": "./src/components/img/poligono/ic_flag_blue.png",
	"./poligono/ic_flag_green.png": "./src/components/img/poligono/ic_flag_green.png",
	"./poligono/ic_flag_grey.png": "./src/components/img/poligono/ic_flag_grey.png",
	"./poligono/ic_flag_orange.png": "./src/components/img/poligono/ic_flag_orange.png",
	"./poligono/ic_flag_red.png": "./src/components/img/poligono/ic_flag_red.png",
	"./poligono/ic_flag_yellow.png": "./src/components/img/poligono/ic_flag_yellow.png",
	"./poligono/info.png": "./src/components/img/poligono/info.png",
	"./poligono/light.png": "./src/components/img/poligono/light.png",
	"./poligono/primary.png": "./src/components/img/poligono/primary.png",
	"./poligono/success.png": "./src/components/img/poligono/success.png",
	"./poligono/warning.png": "./src/components/img/poligono/warning.png",
	"./porta_bau_aberta48.png": "./src/components/img/porta_bau_aberta48.png",
	"./porta_bau_lateral_aberta6.png": "./src/components/img/porta_bau_lateral_aberta6.png",
	"./restart48.png": "./src/components/img/restart48.png",
	"./revert_100dp.png": "./src/components/img/revert_100dp.png",
	"./road3.png": "./src/components/img/road3.png",
	"./settings48.png": "./src/components/img/settings48.png",
	"./shield_lock48.png": "./src/components/img/shield_lock48.png",
	"./table48.png": "./src/components/img/table48.png",
	"./temperature_timer.png": "./src/components/img/temperature_timer.png",
	"./text-box-multiple.png": "./src/components/img/text-box-multiple.png",
	"./text_box_search48.png": "./src/components/img/text_box_search48.png",
	"./thermometer_plus24.png": "./src/components/img/thermometer_plus24.png",
	"./thermometer_plus24b.png": "./src/components/img/thermometer_plus24b.png",
	"./timer48.png": "./src/components/img/timer48.png",
	"./timer_search48.png": "./src/components/img/timer_search48.png",
	"./transparent.png": "./src/components/img/transparent.png",
	"./trash24.png": "./src/components/img/trash24.png",
	"./trash24_gray.png": "./src/components/img/trash24_gray.png",
	"./truck_open_48.png": "./src/components/img/truck_open_48.png",
	"./user.png": "./src/components/img/user.png",
	"./user1.png": "./src/components/img/user1.png",
	"./vector_car1_48.png": "./src/components/img/vector_car1_48.png",
	"./vector_car2_48.png": "./src/components/img/vector_car2_48.png",
	"./vector_square.png": "./src/components/img/vector_square.png",
	"./vector_square2.png": "./src/components/img/vector_square2.png",
	"./vector_square3.png": "./src/components/img/vector_square3.png",
	"./vector_square6.png": "./src/components/img/vector_square6.png",
	"./vector_square7.png": "./src/components/img/vector_square7.png",
	"./window_maximize24.png": "./src/components/img/window_maximize24.png",
	"./window_minimize.png": "./src/components/img/window_minimize.png",
	"./window_restore24.png": "./src/components/img/window_restore24.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/img sync recursive ^\\.\\/.*\\.png$";